import ScrollReveal from "@/components/base/ScrollReveal";
import { motion } from "framer-motion";

const certifications = [
  { icon: "ri-check-line", label: "Produção Própria" },
  { icon: "ri-check-line", label: "Indústria Alimentícia" },
  { icon: "ri-check-line", label: "Atacado e Varejo" },
  { icon: "ri-check-line", label: "Eventos Corporativos" },
  { icon: "ri-check-line", label: "Fortaleza - Ce" },
];

export default function TrustBadge() {
  return (
    <section className="relative w-full py-10 md:py-14 bg-background-50 overflow-hidden bg-grain-subtle">
      {/* Top fade transition from Hero */}
      <div className="absolute top-0 left-0 w-full h-16 bg-gradient-to-b from-background-50/0 to-background-50 pointer-events-none"></div>

      <div className="relative w-full px-4 sm:px-6 md:px-10 max-w-3xl mx-auto">
        <ScrollReveal>
          <div className="relative p-8 md:p-12 rounded-3xl bg-background-100/80 border border-background-300/40 text-center card-glow">
            {/* Top seal emblem */}
            <div className="absolute -top-6 left-1/2 -translate-x-1/2">
              <div className="w-12 h-12 rounded-full bg-primary-100 border-4 border-background-50 flex items-center justify-center seal-ring">
                <i className="ri-verified-badge-fill text-primary-600 text-xl"></i>
              </div>
            </div>

            {/* Main seal number */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
              className="mt-4 mb-6"
            >
              <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-none">
                Desde{" "}
                <span className="gradient-text-warm">2005</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-2 font-medium tracking-wide">
                Tradição, qualidade e sabor em Fortaleza
              </p>
            </motion.div>

            {/* Decorative separator */}
            <div className="decorative-line-curve mb-6 pb-4">
              <div className="w-16 h-px mx-auto bg-gradient-to-r from-transparent via-primary-300/50 to-transparent"></div>
            </div>

            {/* Certification pills */}
            <div className="flex flex-wrap justify-center gap-2.5">
              {certifications.map((cert, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 8 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.1 + i * 0.07, ease: [0.25, 0.1, 0.25, 1] }}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-300/40 transition-colors duration-300 cursor-default"
                >
                  <span className="w-4 h-4 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                    <i className={`${cert.icon} text-primary-600 text-[10px]`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{cert.label}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}